import { is_X_Ratio } from './Scales';

export const useHeaderHeight = () => {
  const headerHeight = 64;
 const HEADER_HIGHT_WITH_BOTTOM_AREA = headerHeight + (is_X_Ratio ? 32 : 0);
  return { HEADER_HIGHT_WITH_BOTTOM_AREA };
};
